import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppContext } from 'Context/ReactAppContext';
import {
  getFromSessionStorage,
  setInSessionStorage,
} from 'Client/session-storage-api/sessionStorageApi';
import { getCustomerSearchResult } from 'Store/booking/booking.selector';
import { renderInfoBanner } from 'Components/widgets/info-banner/infoBanner.utils';
import type { InfoBannerData } from 'Components/widgets/info-banner/infoBanner.query';
import 'Components/widgets/info-banner/infoBanner.query';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { ContactInfo } from 'Components/widgets/contact-info/ContactInfo';
import { asInfoBannerArgs, makeViewProps } from 'Src/types/view-helpers';
import { NotificationLoginToPle } from './login-to-ple/NotificationLoginToPle';
import { PopinLoginToPle } from './login-to-ple/PopinLoginToPle';
const SESSION_STORAGE_ITEM = 'seenProposalsForPopin';
type Props = {
  goToNextStep: (params?: { queryParams: Record<string, string> }) => Promise<unknown>;
  i18n: I18N;
  proposals: Array<Proposal>;
  selectedProposal: Proposal;
  infoBannerData: InfoBannerData;
};
export const ParticipantsView = ({
  goToNextStep,
  i18n,
  proposals,
  selectedProposal,
  infoBannerData,
}: Props) => {
  const appContext = useAppContext();
  const [isAlreadySeen, setIsAlreadySeen] = useState(false);
  const customerSearchResult = useSelector(getCustomerSearchResult);
  const concatProposalIds = proposals.map(({ id }) => id).join('');
  const [shouldShowConnectToPlePopin, setShouldShowConnectToPlePopin] = useState(
    getFromSessionStorage(SESSION_STORAGE_ITEM) !== concatProposalIds,
  );
  useEffect(() => {
    if (getFromSessionStorage(SESSION_STORAGE_ITEM) !== concatProposalIds) {
      setInSessionStorage(SESSION_STORAGE_ITEM, concatProposalIds as any);
    }
  }, [concatProposalIds]);
  useEffect(() => {
    if (customerSearchResult.data && isAlreadySeen === false) {
      setIsAlreadySeen(true);
    }
  }, [customerSearchResult]);
  const userLogged = appContext.isUserLogged;
  const isPopinPleEnabled =
    !userLogged && isFeatureFlipped(appContext)('connectionPopinPLE.isEnabled');
  const isMiniaturizedLoginButton = isFeatureFlipped(appContext)(
    'participantPageConnection.miniaturizedButton',
  );
  const displayNotification = !userLogged && i18n?.account?.authenticated?.greeting;

  const closeLoginToPLEModal = () => {
    setShouldShowConnectToPlePopin(false);
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-start">
      {isPopinPleEnabled && shouldShowConnectToPlePopin && (
        <PopinLoginToPle i18n={i18n} onClose={closeLoginToPLEModal} />
      )}
      <div className="max-w-site-mini sm:mx-auto">
        {renderInfoBanner(
          asInfoBannerArgs({
            infoBannerData,
            departureDate: selectedProposal.departureDate,
            arrivalDate: selectedProposal.arrivalDate,
            currentStep: 'participants',
          }),
        )}
        {displayNotification && !isMiniaturizedLoginButton && (
          <div className="w-full">
            <NotificationLoginToPle
              {...makeViewProps<any>({
                className: 'mb-20',
                isQuickLogged: appContext.isUserQuickLogged,
                i18n,
              })}
            />
          </div>
        )}

        <ContactInfo goToNextStep={goToNextStep} i18n={i18n} proposal={selectedProposal} />
      </div>
    </div>
  );
};
